export default class UserModel {
    id?: number
    name?: string
    userName?: string
    email?: string
    created?: string
    token?: string
    hasPasskey?: boolean

    static fromJson(json: any): UserModel {
        return Object.assign(new UserModel(), json)
    }

    toString(): string {
        return JSON.stringify(this)
    }
}
